import AppMediumState from "@/models/Settings/AppMediums/AppMediumState";

export default class AppMedium {
    id: string = '';
    name: string = '';
    state: AppMediumState = AppMediumState.Disabled;
    accessTokenLifetime: number = 0;
    refreshTokenLifetime: number = 0;
    whitelist: string[] = [];
    xAppMediumHeader: string = '';
    type: string = '';
    createdAt: Date = new Date();
    updatedAt: Date = new Date();
}